export const requestOptions = {
  getRankingInfo: true,
  distinct: true,
  facets: ['*'],
}

export const algoliaDefaultValues = {
  tags: [],
  cup_size: [],
  band_size: [],
  price_ratio: [],
  size: [],
  color: [],
  sort: '',
  category: [],
  categories: [],
}

const filteredProducts: readonly string[] = [
  'Set Bottoms',
  'Intimates Set Bottoms',
  'Intimates Set Skirt',
  'Swim Set Bottoms',
  'Apparel Set Bottoms',
]

export const algoliaGlobalFilter = `(${filteredProducts
  .map((productType) => `NOT product_type:"${productType}"`)
  .join(' AND ')}) AND inventory_available:true`
